export const AUTH_CONFIG = {
    domain: 'brikl.eu.auth0.com',
    connection: 'Username-Password-Authentication',
    clientId: (document.location.hostname === "discovery.brikl.io") ? 'EI10rSZ8NYD0w5tCvpYeCUrhVYq4aBhq' : (document.location.hostname === "staging.discovery.brikl.io") ? "CVLNILSQbodGup4U1GChdc7DMkF1HmlG" : "0tsDtt4aB8RA2Hta7PVRnBqtLEFjQVqW",
    callbackUrl: (document.location.hostname === "discovery.brikl.io") ? 'https://discovery.brikl.io/callback' : (document.location.hostname === "staging.discovery.brikl.io") ? "https://staging.discovery.brikl.io/callback" : "http://localhost:6060/callback"
  }


// WEBPACK FOOTER //
// ./src/auth0-variables.js